const cardPopupBtns = document.querySelectorAll('.card__popup-btn');

cardPopupBtns.forEach((cardPopupBtn) => {
  cardPopupBtn.addEventListener('click', () => {
    const parent = cardPopupBtn.closest('.card');
    const popup = parent.querySelector('.card__popup');
    const close = popup.querySelector('.card__popup-close');

    popup.classList.add('is-open');

    close.addEventListener('click', () => {
      popup.classList.remove('is-open');
    });
  });
});
